import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { UnidadePessoaHistorico } from "./typings/unidade";



interface FiltroUnidadePessoasHistoricoQuery extends PaginateQuery {
    unidadeId: string;
}

function useUnidadePessoasHistorico(
    query: FiltroUnidadePessoasHistoricoQuery,
    enabled = true
) {
    return useQuery(
        `/v1/unidades/${query.unidadeId}/pessoas?${query.page}-${query.limit}-${query.search}/historico`,
        async () => {
            const res = await axios.get<
                PaginateResult<UnidadePessoaHistorico>
            >(`/v1/unidades/${query.unidadeId}/pessoas/historico`, {
                params: { ...query },
            });

            return res.data;
        },
        {
            enabled: !!query.unidadeId && enabled,
        }
    );
}

export default useUnidadePessoasHistorico;
